import React from 'react';
import { COLORS, SHADOWS } from 'config/theme';
import styled from 'styled-components';

const StyledButtonSecond = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 172px;
  height: 36px;
  padding: 0 15px;
  background-color: rgba(98, 2, 238, 0);
  border: solid 1px ${COLORS.primaryLight};
  border-radius: 25px;

  color: ${COLORS.primaryColor};
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;

  transition: all 0.25s;

  &:hover {
    box-shadow: ${SHADOWS[2]};
  }

  svg, img {
    margin-right: 8px;
  }
`;

const ButtonSecond = ({ children }) => {
  return (
    <StyledButtonSecond>
      {children}
    </StyledButtonSecond>
  );
};

export default ButtonSecond;



// WEBPACK FOOTER //
// ./src/components/common/ButtonSecond/ButtonSecond.js